
import User from "@/types/User";
import { computed, defineComponent, PropType } from "vue";
import PeoplePicker from "../Controls/PeoplePicker.vue";
import UserPill from "@/Components/Shared/UserPill.vue";
import CategoryPill from "@/Components/General/CategoryPill.vue";
import RfpCategory from "@/types/Rfp/RfpCategory";
import RfpCategorySelect from "./RfpCategorySelect.vue";

export default defineComponent({
  components: { UserPill, PeoplePicker, CategoryPill, RfpCategorySelect },
  props: {
    allCategories: {
      type: Object as PropType<RfpCategory[]>,
      required: true,
    },
    modelValue: {
      type: Object as PropType<number[]>,
      default: () => [],
    },
    shownCategories: {
      type: Object as PropType<RfpCategory[]>,
      default: () => [],
    },
    mode: {
      type: String,
      default: () => "view",
      validator: (value: string) => {
        return ["view", "edit"].indexOf(value) !== -1;
      },
    },
  },
  emits: ["update:modelValue"],
  setup(props, context) {
    const value = computed({
      get: () => props.modelValue,
      set: (v) => {
        context.emit("update:modelValue", v);
      },
    });

    return {
      value,
    };
  },
});
